import { ethers } from 'ethers';
import { formatUnits as formatUnits$1 } from 'ethers/lib/utils';
import { BigNumber } from '@ethersproject/bignumber';
import { parseUnits, formatUnits } from '@ethersproject/units';

var expression = /^(\w{6})\w*(\w{4})$/;
/**
 * Shortens a hash into something a little more user friendly
 * @param hash
 * @returns
 */

var shorten = function shorten(params) {
  var result;

  if (!params.hash) {
    return null;
  }

  result = expression.exec(params.hash);

  if (!result) {
    return null;
  }

  return params["short"] ? result[1] + "..." : result[1] + "..." + result[2];
};
/**
 * Returns the string used for urls
 * @param {string} tokenSymbol string
 * @param {string} address string
 * @returns
 */

var getPrizePoolSymbol = function getPrizePoolSymbol(tokenSymbol, address) {
  return tokenSymbol.toUpperCase() + "-" + address.slice(0, 8);
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

/**
 * Constant for chain ids
 */
var NETWORK = /*#__PURE__*/Object.freeze({
  'mainnet': 1,
  'homestead': 1,
  'ropsten': 3,
  'rinkeby': 4,
  'goerli': 5,
  'kovan': 42,
  'bsc': 56,
  'poa-sokol': 77,
  'bsc-testnet': 97,
  'poa': 99,
  'xdai': 100,
  'polygon': 137,
  'matic': 137,
  'mumbai': 80001,
  'optimism': 10,
  'optimism-goerli': 420,
  'avalanche': 43114,
  'fuji': 43113,
  'celo': 42220,
  'celo-testnet': 44787,
  'arbitrum': 42161,
  'arbitrum-goerli': 421613
});
/**
 * Ethereum networks
 */

var ETHEREUM_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.mainnet, NETWORK.goerli]);
var POLYGON_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.polygon, NETWORK.mumbai]);
var AVALANCHE_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.avalanche, NETWORK.fuji]);
var CELO_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.celo, NETWORK['celo-testnet']]);
var OPTIMISM_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.optimism, NETWORK['optimism-goerli']]);
var ARBITRUM_NETWORKS = /*#__PURE__*/Object.freeze([NETWORK.arbitrum, NETWORK['arbitrum-goerli']]);

var _GOVERNANCE_CONTRACT_, _Object$freeze;
var getGovernanceSubgraphUrl = function getGovernanceSubgraphUrl(chainId, apiKey) {
  if (chainId === NETWORK.mainnet) {
    return "https://gateway.thegraph.com/api/" + apiKey + "/subgraphs/id/0xa57d294c3a11fb542d524062ae4c5100e0e373ec-0";
  } else {
    return 'https://api.thegraph.com/subgraphs/name/pooltogether/pooltogether-rinkeby-governance';
  }
};
var GOVERNANCE_CONTRACT_ADDRESSES = (_GOVERNANCE_CONTRACT_ = {}, _GOVERNANCE_CONTRACT_[NETWORK.mainnet] = {
  GovernorAlpha: '0xB3a87172F555ae2a2AB79Be60B336D2F7D0187f0',
  GovernanceToken: '0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e',
  GovernanceReserve: '0xdb8E47BEFe4646fCc62BE61EEE5DF350404c124F',
  MerkleDistributor: '0xBE1a33519F586A4c8AA37525163Df8d67997016f'
}, _GOVERNANCE_CONTRACT_[NETWORK.rinkeby] = {
  GovernorAlpha: '0x9B63243CD27102fbEc9FAf67CA1a858dcC16Ee01',
  GovernanceToken: '0xc4E90a8Dc6CaAb329f08ED3C8abc6b197Cf0F40A',
  GovernanceReserve: '0xA5224da01a5A792946E4270a02457EB75412c84c',
  MerkleDistributor: '0x93a6540DcE05a4A5E5B906eB97bBCBb723768F2D'
}, _GOVERNANCE_CONTRACT_[NETWORK.polygon] = {
  GovernanceToken: '0x25788a1a171ec66Da6502f9975a15B609fF54CF6'
}, _GOVERNANCE_CONTRACT_);
var POOL_ADDRESSES = /*#__PURE__*/Object.freeze((_Object$freeze = {}, _Object$freeze[NETWORK.mainnet] = {
  pool: '0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e',
  ppool: '0x27d22a7648e955e510a40bdb058333e9190d12d4'
}, _Object$freeze[NETWORK.rinkeby] = {
  pool: '0xc4E90a8Dc6CaAb329f08ED3C8abc6b197Cf0F40A'
}, _Object$freeze[NETWORK.polygon] = {
  polygon_bridge: '0x25788a1a171ec66Da6502f9975a15B609fF54CF6',
  ppool: '0xd80eaa761ccfdc8698999d73c96cec39fbb1fc48'
}, _Object$freeze[NETWORK.optimism] = {
  pool: '0x395ae52bb17aef68c2888d941736a71dc6d4e125'
}, _Object$freeze));

var addTokenToMetaMask = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(token) {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(!ethereum || !token || !token.address || !token.symbol || !token.decimals || !token.image)) {
              _context.next = 3;
              break;
            }

            throw new Error();

          case 3:
            _context.next = 5;
            return ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20',
                options: token
              }
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.log('Token not added');
            console.log(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function addTokenToMetaMask(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addPoolTokenToMetaMask = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(chainId) {
    var _POOL_ADDRESSES$chain;

    var poolTokenAddress;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            poolTokenAddress = (_POOL_ADDRESSES$chain = POOL_ADDRESSES[chainId]) == null ? void 0 : _POOL_ADDRESSES$chain.pool;
            return _context2.abrupt("return", addTokenToMetaMask({
              address: poolTokenAddress,
              symbol: 'POOL',
              decimals: 18,
              image: 'https://app.pooltogether.com/pooltogether-token-logo@2x.png'
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addPoolTokenToMetaMask(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var addUsdcTicketTokenToMetaMask = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(token) {
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", addTokenToMetaMask(_extends({}, token, {
              decimals: 6,
              image: 'https://app.pooltogether.com/ptausdc.png'
            })));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function addUsdcTicketTokenToMetaMask(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var _excluded = ["locale", "round"];
/**
 * Slices a number string to the requested precision
 * @param {string} val a number string ex. "1005.2924"
 * @param {FormatNumberOptions} options
 * @returns
 */

function stringWithPrecision(val, options) {
  if (options === void 0) {
    options = {
      precision: 2
    };
  }

  var _options = options,
      precision = _options.precision;

  if (val && typeof val.indexOf === 'function') {
    var extraChars = precision ? precision + 1 : 0;
    return val.substr(0, val.indexOf('.') + extraChars);
  } else {
    return val;
  }
}
/**
 * Converts a USD string to a scaled up big number to account for cents
 * @param {string} usd a String ex. "100.23"
 * @returns a BigNumber ex. 10023
 */

var toScaledUsdBigNumber = function toScaledUsdBigNumber(usd) {
  return parseUnits(stringWithPrecision(usd, {
    precision: 2
  }), 2);
};
/**
 * Converts a scaled USD BigNumber to a string
 * @param {string} usdScaled a scaled BigNumber ex. ethers.BigNumber.from("10023") (Which would be $100.23)
 * @returns a string ex. "100.23"
 */

var toNonScaledUsdString = function toNonScaledUsdString(usdScaled) {
  return formatUnits(usdScaled, 2);
};
/**
 * Returns a formatted string for a percentage
 * @param percentage
 * @returns
 */

function displayPercentage(percentage) {
  percentage = parseFloat(percentage).toFixed(2);
  return percentage.toString().replace(/(\.0+$)|(0+$)/, '');
}
/**
 * Convert a string and decimals/unit to a BigNumber using a guarded try/catch
 * @param {String} valueString string number represtation to format
 * @param {Number|String} decimalsOrUnitName number of decimal places in parent ERC20 contract or ETH unit name
 * @returns {BigNumber|undefined} The parsed BigNumber or undefined if failed to parse
 */

var safeParseUnits = function safeParseUnits(valueString, decimalsOrUnitName) {
  try {
    return parseUnits(valueString, decimalsOrUnitName);
  } catch (e) {
    console.warn('could not run parseUnits on values:', valueString, decimalsOrUnitName);
    return undefined;
  }
};
/**
 * Formats a number to make it legible
 * @param _amount
 * @param options
 * @returns
 */

var formatNumberForDisplay = function formatNumberForDisplay(_amount, options) {
  if (options === void 0) {
    options = {
      locale: 'en'
    };
  }

  var _options2 = options,
      locale = _options2.locale,
      round = _options2.round,
      formatOptions = _objectWithoutPropertiesLoose(_options2, _excluded);

  var amount;

  if (typeof _amount === 'number') {
    amount = _amount;
  } else if (typeof _amount === 'string') {
    amount = Number(_amount);
  } else if (!!_amount._isBigNumber) {
    amount = _amount.toNumber();
  }

  if (!!round) {
    amount = Math.round(amount);
  }

  return amount.toLocaleString(locale || 'en', _extends({}, formatOptions));
};
/**
 * Wraps formatNumberForDisplay and handles shifting decimals of a BigNumber
 * @param _amount
 * @param decimals
 * @param options
 * @returns
 */

var formatUnformattedBigNumberForDisplay = function formatUnformattedBigNumberForDisplay(_amount, decimals, options) {
  if (options === void 0) {
    options = {
      locale: 'en'
    };
  }

  return formatNumberForDisplay(formatUnits(_amount, decimals), options);
};
var CURRENCIES;

(function (CURRENCIES) {
  CURRENCIES["USD"] = "USD";
  CURRENCIES["CAD"] = "CAD";
  CURRENCIES["EUR"] = "EUR";
})(CURRENCIES || (CURRENCIES = {}));
/**
 * Wraps formatNumberForDisplay and handles shifting decimals of a BigNumber
 * @param _amount
 * @param decimals
 * @param options
 * @returns
 */


var formatCurrencyNumberForDisplay = function formatCurrencyNumberForDisplay(_amount, currency, options) {
  if (currency === void 0) {
    currency = 'USD';
  }

  if (options === void 0) {
    options = {
      locale: 'en'
    };
  }

  return formatNumberForDisplay(_amount, _extends({}, options, {
    style: 'currency',
    currency: currency
  }));
};
var EMPTY_AMOUNT = {
  amount: '',
  amountUnformatted: undefined,
  amountPretty: '',
  decimals: ''
};
/**
 * Accepts a number and returns several useful variations of that number
 * TODO: Remove the empty amount and return null. It's a hacky fallback so you don't need to check if data has been fetched when formatting.
 * @param amount
 * @param decimals
 * @param options
 * @returns
 */

var getAmount = function getAmount(_amount, decimals, options) {
  if (options === void 0) {
    options = {
      locale: 'en'
    };
  }

  try {
    if (!_amount || _amount === undefined || !decimals || decimals === undefined) {
      return EMPTY_AMOUNT;
    }

    if (typeof _amount === 'string') {
      return {
        amount: _amount,
        amountUnformatted: ethers.utils.parseUnits(_amount, decimals),
        amountPretty: formatNumberForDisplay(_amount, options),
        decimals: decimals
      };
    } else if (typeof _amount === 'number') {
      return {
        amount: _amount.toString(),
        amountUnformatted: ethers.utils.parseUnits(_amount.toString(), decimals),
        amountPretty: formatNumberForDisplay(_amount, options),
        decimals: decimals
      };
    } else if (!!_amount._isBigNumber) {
      return {
        amountUnformatted: _amount.mul(ethers.BigNumber.from(10).pow(ethers.BigNumber.from(decimals))),
        amount: _amount.toString(),
        amountPretty: formatNumberForDisplay(_amount, options),
        decimals: decimals
      };
    } else {
      return EMPTY_AMOUNT;
    }
  } catch (e) {
    console.error(e.message);
    return EMPTY_AMOUNT;
  }
};
/**
 * Accepts a decimal shifted number and returns several useful variations of that number
 * @param amount
 * @param decimals
 * @param options
 * @returns
 */

var getAmountFromUnformatted = function getAmountFromUnformatted(_unformattedAmount, decimals, options) {
  if (options === void 0) {
    options = {
      locale: 'en'
    };
  }

  if (typeof _unformattedAmount === 'string') {
    return getAmount(ethers.utils.formatUnits(BigNumber.from(_unformattedAmount), decimals), decimals, options);
  } else if (!!_unformattedAmount._isBigNumber) {
    return getAmount(ethers.utils.formatUnits(_unformattedAmount, decimals), decimals, options);
  } else {
    return EMPTY_AMOUNT;
  }
};
/**
 * Pretty up a BigNumber using it's corresponding ERC20 decimals value with the proper amount of
 * trailing decimal precision
 * @param {BigNumber|String|Number} amount number to format
 * @param {Object} options
 * @param {Number} options.decimals  precision to use when converting from BigNumber to string
 * @param {Number} options.precision ignore determining how many decimals to display and use the num passed in
 * example: a BigNumber value of 123456 for WBTC which has 8 decimals of precision
 *          would be formatted as: 0.00123456
 */

var numberWithCommas = function numberWithCommas(amount, options) {
  if (options === void 0) {
    options = {};
  }

  if (!options.decimals) {
    options.decimals = 18;
  }

  if (amount === undefined || amount === null) {
    return undefined;
  }

  var amountFormatted = amount._isBigNumber ? ethers.utils.formatUnits(amount, options.decimals) : amount;

  if (!options.precision && options.precision !== 0 && amountFormatted) {
    options.precision = getPrecision(amountFormatted);
  }

  return _formatCommas(amountFormatted, options);
};

function _formatCommas(str, options) {
  if (options === void 0) {
    options = {};
  }

  var precision = 2;

  if (options.precision !== undefined) {
    precision = options.precision;
  }

  var localeString = 'en-GB';

  if (options.currentLang && options.currentLang === 'es') {
    localeString = 'es-ES';
  } // auto-round to the nearest whole number


  if (precision === 0) {
    str = Math.floor(Number(str));
  }

  if (precision === 2) {
    // Properly round
    // https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary
    str = Math.round((parseFloat(str) + Number.EPSILON) * 100) / 100;
  } // handle exponents


  if (str.toString().match('e')) {
    str = Number.parseFloat(str).toFixed(0);
  }

  var parts = str.toString().split('.');
  parts[0] = parts[0].replace(',', '');
  var numberStr = '';

  if (parts.length > 1 && precision > 0) {
    numberStr = stringWithPrecision(parts.join('.'), {
      precision: precision
    });
  } else {
    numberStr = parts[0];
  }

  if (options.removeTrailingZeros) {
    numberStr = numberStr.replace(/(\.0+|0+)$/, '');
  }

  return Number(numberStr).toLocaleString(localeString, {
    minimumFractionDigits: options.removeTrailingZeros ? 0 : precision
  });
}
/**
 * Returns a standardized decimal precision depending on the number
 * @param {*} num number to check
 */


var getPrecision = function getPrecision(num) {
  num = parseFloat(num);

  if (num > 10000) {
    return 0;
  } else if (num >= 0.1) {
    return 2;
  } else {
    return getMinPrecision(num);
  }
};
/**
 * Returns the number of digits after a decimal place
 * @param {*} num number to check
 */

var getMaxPrecision = function getMaxPrecision(num) {
  var _String$split$;

  return ((_String$split$ = String(num).split('.')[1]) == null ? void 0 : _String$split$.length) || 0;
};
/**
 * Counts the number of 0's past a decimal in a number and returns how many significant digits to keep
 * plus additional digits so we always show a non-zero number.
 * @param {*} num number to check
 * @param {*} options
 *    additionalDigits: Optional additional digits to keep past the first non-zero number
 */

var getMinPrecision = function getMinPrecision(num, options) {
  if (options === void 0) {
    options = {
      additionalDigits: 2
    };
  }

  var _options3 = options,
      additionalDigits = _options3.additionalDigits;
  var decimals = String(num).split('.')[1];
  if (decimals === '0') return 0;
  if (!decimals) return additionalDigits;
  return decimals.match(/^0*/)[0].length + additionalDigits;
};
/**
 * Returns a human readable version of a BigNumber w/ decimals
 * @param BigNumber amount
 * @param string decimals
 */

var prettyNumber = function prettyNumber(amount, decimals) {
  return numberWithCommas(amount, {
    decimals: decimals
  });
};

// Seconds
var SECONDS_PER_MINUTE = 60;
var SECONDS_PER_HOUR = 3600;
var SECONDS_PER_DAY = 86400;
var SECONDS_PER_YEAR = 31536000; // Minutes

var MINUTES_PER_HOUR = 60;
var MINUTES_PER_DAY = 1440;

/**
 * Need to mult & div by 100 since BigNumber doesn't support decimals
 * @param {ethers.BigNumber} amount as a BigNumber
 * @param {number} usd as a Number
 * @returns a BigNumber
 */

var amountMultByUsd = function amountMultByUsd(amount, usd) {
  return amount.mul(Math.round(usd * 100)).div(100);
};
/**
 * Adds a list of BigNumbers
 * @param {ethers.BigNumber[]} nums an array of scaled BigNumbers
 * @returns
 */

var addBigNumbers = function addBigNumbers(nums) {
  return nums.reduce(function (total, bn) {
    return bn.add(total);
  }, ethers.constants.Zero);
};
/**
 * Calculate odds of winning at least 1 of the possible scenarios.
 * 1/N, 2/N ... N-1/N, N/N
 * Then we always display "1 in ____" so 1 / X.
 *
 * `usersTicketBalance` and `totalSupply` must be formatted with the same `decimals`
 *
 * @param usersTicketBalance
 * @param totalSupply
 * @param decimals
 * @param numberOfWinners
 * @returns
 */

var calculateUsersOdds = function calculateUsersOdds(usersTicketBalance, totalSupply, decimals, numberOfWinners) {
  if (!usersTicketBalance || usersTicketBalance.eq(ethers.BigNumber.from(0)) || !decimals) {
    return 0;
  }

  var numOfWinners = parseInt(numberOfWinners, 10);
  var usersBalanceFloat = Number(ethers.utils.formatUnits(usersTicketBalance, Number(decimals)));
  var totalSupplyFloat = Number(ethers.utils.formatUnits(totalSupply, Number(decimals)));
  return 1 / (1 - Math.pow((totalSupplyFloat - usersBalanceFloat) / totalSupplyFloat, numOfWinners));
};
/**
 * Calculates the estimated yield for a prize pool
 * Yield = total supply * supply rate per block * blocks * reserve percentage
 *
 * @param existingPrizeUnformatted BigNumber - same decimals as poolDepositsTotalSupplyUnformatted, supplyRatePerBlockUnformatted
 * @param poolDepositsTotalSupplyUnformatted BigNumber - same decimals as existingPrizeUnformatted, supplyRatePerBlockUnformatted
 * @param supplyRatePerBlockUnformatted BigNumber - Shifted 18 decimals
 * @param decimals decimals used to format the above parameters
 * @param prizePeriodRemainingBlocks ex. "23034.23"
 * @param prizePeriodRemainingSeconds ex. "322003"
 * @param poolReserveRate ex. "0.5"
 * @param compApy ex "2.39234 "
 * @returns BigNumber
 */

var calculateEstimatedCompoundPrizeWithYieldUnformatted = function calculateEstimatedCompoundPrizeWithYieldUnformatted(existingPrizeUnformatted, poolDepositsTotalSupplyUnformatted, supplyRatePerBlockUnformatted, decimals, prizePeriodRemainingBlocks, poolReserveRate) {
  // Format to same decimal places, so we keep accuracy for floats
  var poolReserveRateUnformatted = poolReserveRate && parseFloat(poolReserveRate) !== 0 ? ethers.utils.parseUnits(parseFloat(poolReserveRate).toFixed(Number(decimals)), decimals) : ethers.constants.Zero; // Additional divison to handle decimal placements

  var prizeYield = poolReserveRateUnformatted.isZero() ? ethers.constants.Zero : poolDepositsTotalSupplyUnformatted.mul(supplyRatePerBlockUnformatted).mul(Math.round(parseFloat(prizePeriodRemainingBlocks))).mul(poolReserveRateUnformatted).div(ethers.utils.parseUnits('1', 18)) // Format for supplyRatePerBlockUnformatted
  .div(ethers.utils.parseUnits('1', decimals));
  return prizeYield.add(existingPrizeUnformatted);
};
/**
 * Estimates the value of the COMP that will be earned from supplying to Compound
 * @param compApy
 * @param poolDepositsTotalValueUsdScaled
 * @param prizePeriodRemainingSeconds
 * @returns BigNumber
 */

var calculatedEstimatedAccruedCompTotalValueUsdScaled = function calculatedEstimatedAccruedCompTotalValueUsdScaled(compApy, poolDepositsTotalValueUsdScaled, prizePeriodRemainingSeconds) {
  // Estimate accrued comp that will be
  if (compApy) {
    var compYearlyEarningsUnformatted = poolDepositsTotalValueUsdScaled.mul(Math.round(parseFloat(compApy) * 100)).div(10000);
    var compEarningsPerSecondUnformatted = compYearlyEarningsUnformatted.mul(100).div(SECONDS_PER_YEAR);
    return compEarningsPerSecondUnformatted.mul(prizePeriodRemainingSeconds).div(100);
  } else {
    return ethers.constants.Zero;
  }
};
/**
 * Calculates the value of an LP token for the 2 provided tokens
 * Make sure the BigNumbers are formatted with the same decimals
 * @param totalValueOfLPPool
 * @param totalSupplyOfLPTokens
 * @returns
 */

var calculateLPTokenPrice = function calculateLPTokenPrice(token1Amount, token2Amount, token1ValueUsd, token2ValueUsd, totalSupplyOfLPTokens) {
  var normalizedTotalValue = addBigNumbers([amountMultByUsd(parseUnits(token1Amount, 18), token1ValueUsd), amountMultByUsd(parseUnits(token2Amount, 18), token2ValueUsd)]);
  var normalizedTotalSupply = parseUnits(totalSupplyOfLPTokens, 18);
  return normalizedTotalValue.div(normalizedTotalSupply);
};
/**
 * Calculate Cream borrow APY with values from crToken & interest rate model contracts
 * @param baseUnformatted
 * @param multiplierUnformatted
 * @param utilizationRateUnformatted
 * @param kink1Unformatted
 * @param kink2Unformatted
 * @param jumpMultiplierUnformatted
 * @param blocksPerYearBN
 * @returns
 */

var calculateCreamBorrowApy = function calculateCreamBorrowApy(baseUnformatted, multiplierUnformatted, utilizationRateUnformatted, kink1Unformatted, kink2Unformatted, jumpMultiplierUnformatted, blocksPerYearBN) {
  var base = Number(formatUnits(baseUnformatted, 18));
  var multiplier = Number(formatUnits(multiplierUnformatted, 18));
  var utilizationRate = Number(formatUnits(utilizationRateUnformatted, 18));
  var kink1 = Number(formatUnits(kink1Unformatted, 18));
  var kink2 = Number(formatUnits(kink2Unformatted, 18));
  var jumpMultiplier = Number(formatUnits(jumpMultiplierUnformatted, 18));
  var blocksPerYear = blocksPerYearBN.toNumber();
  return Math.pow(1 + base + multiplier * Math.min(utilizationRate, kink1) + Math.max(jumpMultiplier * utilizationRate - kink2, 0), blocksPerYear) - 1;
};
/**
 * Calculate Cream supply APY with values from crToken & interest rate model contracts
 * @param borrowApy
 * @param reserveFactorUnformatted
 * @param utilizationRateUnformatted
 * @param blocksPerYearBN
 * @returns
 */

var calculateCreamSupplyApy = function calculateCreamSupplyApy(borrowApy, reserveFactorUnformatted, utilizationRateUnformatted, blocksPerYearBN) {
  var reserveFactor = Number(formatUnits(reserveFactorUnformatted, 18));
  var utilizationRate = Number(formatUnits(utilizationRateUnformatted, 18));
  var blocksPerYear = blocksPerYearBN.toNumber();
  return Math.pow(1 + (Math.pow(1 + borrowApy, 1 / blocksPerYear) - 1) * (1 - reserveFactor) * utilizationRate, blocksPerYear) - 1;
};
/**
 * Assumes the BigNumbers are the same decimals
 * @param totalSupplyAmountUnformatted
 * @param dailyPrizeAmountUnformatted
 * @param precision padding for percentage calculation
 * @returns
 */

var calculateApr = function calculateApr(totalSupplyAmountUnformatted, dailyPrizeAmountUnformatted, precision) {
  if (precision === void 0) {
    precision = 4;
  }

  if (totalSupplyAmountUnformatted.isZero() || dailyPrizeAmountUnformatted.isZero()) {
    return 0;
  }

  var totalYearlyPrizesUnformatted = dailyPrizeAmountUnformatted.mul(365);
  return divideBigNumbers(totalYearlyPrizesUnformatted, totalSupplyAmountUnformatted, precision) * 100;
};
/**
 * Pads two BigNumbers with a set precision then divides to determine the percentage
 * @returns
 */

var divideBigNumbers = function divideBigNumbers(a, b, precision) {
  if (precision === void 0) {
    precision = 4;
  }

  if (a.isZero() || b.isZero()) return 0;
  return Number(formatUnits(a.mul(Math.pow(10, precision)).div(b), String(precision)));
};
/**
 *
 * @param bn BigNumber
 * @param percentage ex. 0.2
 * @param precision ex. 0.2
 * @returns
 */

var calculatePercentageOfBigNumber = function calculatePercentageOfBigNumber(bn, percentage, precision) {
  if (precision === void 0) {
    precision = 4;
  }

  return bn.mul(percentage * Math.pow(10, precision)).div(Math.pow(10, precision));
};

/**
 * Recursively looks through an object, converting all big numbers into actual BigNumbers
 * @param {any} data json blob
 * @returns
 */

var deserializeBigNumbers = function deserializeBigNumbers(data) {
  try {
    if (Array.isArray(data)) {
      data.forEach(deserializeBigNumbers);
    } else if (typeof data === 'object' && data !== null) {
      Object.keys(data).forEach(function (key) {
        if (Array.isArray(data[key])) {
          data[key].forEach(deserializeBigNumbers);
        } else if (typeof data[key] === 'object' && data[key] !== null) {
          var _data$key;

          if (((_data$key = data[key]) == null ? void 0 : _data$key.type) === 'BigNumber') {
            data[key] = ethers.BigNumber.from(data[key]);
          } else {
            deserializeBigNumbers(data[key]);
          }
        }
      });
    }

    return data;
  } catch (e) {
    return data;
  }
};
/**
 * Mutates a token adding token USD value if we have the USD price per token
 * @param {*} token
 */

var addTokenTotalUsdValue = function addTokenTotalUsdValue(token, tokenPriceData) {
  var priceData = tokenPriceData[token.address];

  if (priceData) {
    token.usd = priceData.usd || 0;
    token.derivedETH = priceData.derivedETH || '0';

    if (token.amountUnformatted) {
      var usdValueUnformatted = amountMultByUsd(token.amountUnformatted, token.usd);
      token.totalValueUsd = formatUnits$1(usdValueUnformatted, token.decimals);
      token.totalValueUsdScaled = toScaledUsdBigNumber(token.totalValueUsd);
    }
  } else {
    token.usd = 0;
    token.derivedETH = '0';
  }
};
function dedupeArray(arr) {
  return Array.from(new Set(arr));
}

var getLootBoxKey = function getLootBoxKey(lootBoxAddress, lootBoxId) {
  return "lootBox-" + lootBoxAddress + "-" + lootBoxId;
};

/**
 * Returns the chain id that maps to a provided network alias
 * @param networkAlias alias that maps to a chain id
 * @returns
 */

var getChainIdByAlias = function getChainIdByAlias(networkAlias) {
  return NETWORK == null ? void 0 : NETWORK[networkAlias];
};
/**
 * Returns the network alias that maps to a provided chain id
 * @param chainId chain id that maps to a network alias
 * @returns
 */

var getNetworkNameAliasByChainId = function getNetworkNameAliasByChainId(chainId) {
  var networkKeys = Object.keys(NETWORK);
  var networkAlias = networkKeys.find(function (networkKey) {
    return NETWORK[networkKey] === chainId;
  });

  if (typeof networkAlias === 'undefined') {
    return undefined;
  }

  return networkAlias;
};
/**
 * Returns a formatted name to display in the UI based on the chain id provided
 * @param chainId
 * @returns
 */

var getNetworkNiceNameByChainId = function getNetworkNiceNameByChainId(chainId) {
  switch (Number(chainId)) {
    case NETWORK.mainnet:
      {
        return 'Ethereum';
      }

    case NETWORK.matic:
      {
        return 'Polygon';
      }

    case NETWORK.bsc:
      {
        return 'Binance Smart Chain';
      }

    case NETWORK.celo:
      {
        return 'Celo';
      }

    case NETWORK.xdai:
      {
        return 'xDai';
      }

    default:
      {
        var niceName = getNetworkNameAliasByChainId(chainId);
        return niceName ? niceName.charAt(0).toUpperCase() + niceName.slice(1) : '--';
      }
  }
};
/**
 * Returns the alias with any special cases for renamed networks, etc
 * @param {Number} chainId
 * @returns {String} network name alias
 */

var chainIdToNetworkName = function chainIdToNetworkName(chainId) {
  if (chainId === 137) {
    return 'polygon';
  }

  return getNetworkNameAliasByChainId(chainId);
};

/**
 *
 * @param underlyingAmount
 * @param sharesTotalSupply
 * @param podUnderlyingTokenTotalBalance
 * @returns
 */
var underlyingAmountToSharesAmount = function underlyingAmountToSharesAmount(underlyingAmount, sharesTotalSupply, podUnderlyingTokenTotalBalance) {
  if (podUnderlyingTokenTotalBalance.isZero()) {
    return undefined;
  }

  return underlyingAmount.mul(sharesTotalSupply).div(podUnderlyingTokenTotalBalance);
};
/**
 *
 * @param sharesAmount
 * @param sharesTotalSupply
 * @param podUnderlyingTokenTotalBalance
 * @returns
 */

var sharesAmountToUnderlyingAmount = function sharesAmountToUnderlyingAmount(sharesAmount, sharesTotalSupply, podUnderlyingTokenTotalBalance) {
  if (sharesTotalSupply.isZero()) {
    return undefined;
  }

  return sharesAmount.mul(podUnderlyingTokenTotalBalance).div(sharesTotalSupply);
};

/**
 * Breaks down a number of seconds into years, months, days, hours, minutes, seconds
 * @param totalSeconds
 * @returns
 */

var getTimeBreakdown = function getTimeBreakdown(totalSeconds) {
  var diff = Number(totalSeconds);
  var years = 0;

  if (diff >= SECONDS_PER_YEAR) {
    years = Math.floor(diff / SECONDS_PER_YEAR);
    diff -= years * SECONDS_PER_YEAR;
  }

  var days = 0;

  if (diff >= SECONDS_PER_DAY) {
    days = Math.floor(diff / SECONDS_PER_DAY);
    diff -= days * SECONDS_PER_DAY;
  }

  var hours = 0;

  if (days || diff >= SECONDS_PER_HOUR) {
    hours = Math.floor(diff / SECONDS_PER_HOUR);
    diff -= hours * SECONDS_PER_HOUR;
  }

  var minutes = 0;

  if (hours || diff >= 60) {
    minutes = Math.floor(diff / 60);
    diff -= minutes * 60;
  }

  var seconds = 0;

  if (minutes || diff >= 1) {
    seconds = diff;
  }

  return {
    years: years,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};
/**
 * Simple math to calculate how many seconds are remaining until the prize can be awarded
 * @param prizePeriodSeconds
 * @param prizePeriodStartedAt
 * @returns
 */

var getSecondsRemainingInPrizePeriod = function getSecondsRemainingInPrizePeriod(prizePeriodSeconds, prizePeriodStartedAt) {
  var prizePeriodDurationInSeconds = prizePeriodSeconds.toNumber();
  var prizePeriodStartedAtInSeconds = prizePeriodStartedAt.toNumber();
  var currentTimeInSeconds = getSecondsSinceEpoch();
  var secondsSinceStartOfPrizePeriod = currentTimeInSeconds - prizePeriodStartedAtInSeconds;
  return prizePeriodDurationInSeconds - secondsSinceStartOfPrizePeriod;
};
/**
 * Converts milliseconds to seconds
 * @param milliseconds milliseconds as a number
 * @returns
 */

var msToS = function msToS(milliseconds) {
  if (!milliseconds) {
    return 0;
  }

  return milliseconds / 1000;
};
/**
 * Converts seconds to milliseconds
 * @param seconds seconds as a number
 * @returns
 */

var sToMs = function sToMs(seconds) {
  if (!seconds) {
    return 0;
  }

  return seconds * 1000;
};
/**
 * Converts days to milliseconds
 * @param days days as a number
 * @returns
 */

var dToMs = function dToMs(days) {
  if (!days) {
    return 0;
  }

  return days * SECONDS_PER_DAY * 1000;
};
/**
 * Converts milliseconds to days
 * @param days days as a number
 * @returns
 */

var msToD = function msToD(ms) {
  if (!ms) {
    return 0;
  }

  return ms / 1000 / SECONDS_PER_DAY;
};
/**
 * Converts days to seconds
 * @param days days as a number
 * @returns
 */

var dToS = function dToS(days) {
  if (!days) {
    return 0;
  }

  return days * SECONDS_PER_DAY;
};
/**
 * Converts seconds to days
 * @param s seconds as a number
 * @returns
 */

var sToD = function sToD(s) {
  if (!s) {
    return 0;
  }

  return s / SECONDS_PER_DAY;
};
/**
 * Converts seconds to minutes
 * @param s seconds as a number
 * @returns
 */

var sToM = function sToM(s) {
  if (!s) {
    return 0;
  }

  return s / SECONDS_PER_MINUTE;
};
/**
 * Converts days to minutes
 * @param days days as a number
 * @returns
 */

var dToM = function dToM(days) {
  if (!days) {
    return 0;
  }

  return days * MINUTES_PER_DAY;
};
/**
 * Finds the difference between two date objects
 * @param dateA DateTime JS object (ie. new Date(Date.now()))
 * @param dateB DateTime JS object (ie. new Date(Date.now()))
 * @returns Object with difference split into keys with days, hours, minutes, and seconds
 */

var subtractDates = function subtractDates(dateA, dateB) {
  var msA = dateA.getTime();
  var msB = dateB.getTime();
  var diff = msA - msB;
  var days = 0;

  if (diff >= 86400000) {
    days = diff / 86400000;
    diff -= days * 86400000;
  }

  var hours = 0;

  if (days || diff >= 3600000) {
    hours = diff / 3600000;
    diff -= hours * 3600000;
  }

  var minutes = 0;

  if (hours || diff >= 60000) {
    minutes = diff / 60000;
    diff -= minutes * 60000;
  }

  var seconds = 0;

  if (minutes || diff >= 1000) {
    seconds = diff / 1000;
  }

  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};
/**
 * Converts milliseconds to seconds using bigNum math
 * @param ms Number Milliseconds to convert
 * @returns Number Seconds converted from milliseconds
 */

function msToSeconds(ms) {
  if (!ms) {
    return 0;
  }

  return ethers.BigNumber.from(ms).div(1000).toNumber();
}
/**
 * Return seconds since Epoch as a number
 * @returns Number Seconds since the Unix Epoch
 */

var getSecondsSinceEpoch = function getSecondsSinceEpoch() {
  return Number((Date.now() / 1000).toFixed(0));
};

/**
 * Provides a hex color to match tokens
 * @param tokenAddress
 * @param isDarkMode
 * @returns
 */
var getTokenColour = function getTokenColour(tokenAddress, isDarkMode) {
  if (isDarkMode === void 0) {
    isDarkMode = false;
  }

  if (isDarkMode) {
    return TOKEN_COLORS_DARK[tokenAddress];
  }

  return TOKEN_COLORS[tokenAddress];
};
var TOKEN_COLORS = /*#__PURE__*/Object.freeze({});
var TOKEN_COLORS_DARK = /*#__PURE__*/Object.freeze({});

/**
 * Calculates the odds of winning at least 1 prize
 * odds of winning at least 1 prize = 1 - the odds of not winning any prizes
 * @param balance
 * @param totalSupply
 * @param decimals
 * @param numberOfPrizes
 * @returns
 */

var calculateOdds = function calculateOdds(balance, totalSupply, decimals, numberOfPrizes) {
  if (numberOfPrizes === void 0) {
    numberOfPrizes = 1;
  }

  if (!balance || balance.isZero() || !totalSupply || totalSupply.isZero() || !decimals || numberOfPrizes === 0) {
    return 0;
  }

  var usersBalanceFloat = Number(ethers.utils.formatUnits(balance, decimals));
  var totalSupplyFloat = Number(ethers.utils.formatUnits(totalSupply, decimals));
  return 1 - Math.pow((totalSupplyFloat - usersBalanceFloat) / totalSupplyFloat, numberOfPrizes);
};
/**
 * Compute the union of several probability distributions
 * p(a | b) = p(a) + p(b) - p(a & b)
 * @param args ex. 0.2, 1, 0.5, 0.33
 * @returns
 */

var unionProbabilities = function unionProbabilities() {
  var returnValue = arguments.length <= 0 ? undefined : arguments[0];

  for (var i = 1; i < arguments.length; i++) {
    returnValue = returnValue + (i < 0 || arguments.length <= i ? undefined : arguments[i]) - returnValue * (i < 0 || arguments.length <= i ? undefined : arguments[i]);
  }

  return returnValue;
};

var replaceQueryParam = function replaceQueryParam(key, value) {
  var url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState(null, '', url.toString());
};
var pushQueryParam = function pushQueryParam(key, value) {
  var url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState(null, '', url.toString());
};
var deleteQueryParam = function deleteQueryParam(key) {
  var url = new URL(window.location.href);
  url.searchParams["delete"](key);
  window.history.replaceState(null, '', url.toString());
};

var _PRIZE_POOL_ADDRESSES, _POD_ADDRESSES, _LP_PRIZE_POOL_METADA, _POOL_PRIZE_POOL_ADDR;
var DEXES;

(function (DEXES) {
  DEXES["UniSwap"] = "UniSwap";
  DEXES["SushiSwap"] = "SushiSwap";
})(DEXES || (DEXES = {})); // V3 contract addresses to maintain support for.


var V3 = /*#__PURE__*/Object.freeze({
  CHAIN_IDS: {
    mainnets: [NETWORK.mainnet, NETWORK.polygon, NETWORK.bsc, NETWORK.celo],
    testnets: [NETWORK.rinkeby]
  },
  PRIZE_POOL_ADDRESSES: (_PRIZE_POOL_ADDRESSES = {}, _PRIZE_POOL_ADDRESSES[NETWORK.mainnet] = [{
    prizePool: '0xebfb47a7ad0fd6e57323c8a42b2e5a6a4f68fc1a',
    symbol: 'PT-cDAI',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0xf362ce295f2a4eae4348ffc8cdbce8d729ccb8eb']
  }, {
    prizePool: '0x0650d780292142835f6ac58dd8e2a336e87b4393',
    symbol: 'PT-cUNI',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0xa5dddefd30e234be2ac6fc1a0364cfd337aa0f61']
  }, {
    prizePool: '0xde9ec95d7708b8319ccca4b8bc92c0a3b70bf416',
    symbol: 'PT-cUSDC',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0xbd537257fad96e977b9e545be583bbf7028f30b9']
  }, {
    prizePool: '0x396b4489da692788e327e2e4b2b0459a5ef26791',
    symbol: 'PT-stPOOL',
    subgraphVersion: '3.3.2',
    tokenFaucets: ['0x30430419b86e9512e6d93fc2b0791d98dbeb637b']
  }, {
    prizePool: '0xbc82221e131c082336cf698f0ca3ebd18afd4ce7',
    symbol: 'PT-cCOMP',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0x72f06a78bbaac0489067a1973b0cef61841d58bc']
  }, {
    prizePool: '0xc2a7dfb76e93d12a1bb1fa151b9900158090395d',
    symbol: 'PT-stBADGER',
    subgraphVersion: '3.3.2',
    tokenFaucets: ['0x40f76363129118b34cc2af44963192c3e8690ba6']
  }, {
    prizePool: '0xc32a0f9dfe2d93e8a60ba0200e033a59aec91559',
    symbol: 'PT-xSUSHI',
    subgraphVersion: '3.3.8',
    tokenFaucets: ['0xddcf915656471b7c44217fb8c51f9888701e759a', '0xd186302304fd367488b5087af5b12cb9b7cf7540']
  }, {
    prizePool: '0x3af7072d29adde20fc7e173a7cb9e45307d2fb0a',
    symbol: 'POOL-ETH-UNI-V2-LP',
    subgraphVersion: '3.3.8',
    tokenFaucets: ['0x9a29401ef1856b669f55ae5b24505b3b6faeb370']
  }, {
    prizePool: '0x65c8827229fbd63f9de9fdfd400c9d264066a336',
    symbol: 'gUSD-0x65C882',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x103a8ed831bec3b33a0018a16337fbfd604bbba9',
    symbol: 'RAI-0x103a8e',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x5b746a07d36a9c8583313983d83d2fc029dcf7bf',
    symbol: 'sUSD-0x5b746a',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x244d223c0ad484aa27691c4efd2218a71b240c8c',
    symbol: 'bUSD-0x244D22',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x639d4140a1f7723b7cefef7505d1d7be11a43de0',
    symbol: 'UNI-V2-0x639d41',
    subgraphVersion: '3.1.0'
  }, {
    prizePool: '0xc7d56c06F136EFff93e349C7BF8cc46bBF5D902c',
    symbol: 'USDT-0xc7d56c',
    subgraphVersion: '3.3.8'
  }], _PRIZE_POOL_ADDRESSES[NETWORK.rinkeby] = [{
    prizePool: '0x4706856fa8bb747d50b4ef8547fe51ab5edc4ac2',
    symbol: 'PT-cDAI',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0x5d5af77cf99f7015e615f9b3286a27c5b6090707']
  }, {
    prizePool: '0xab068f220e10eed899b54f1113de7e354c9a8eb7',
    symbol: 'PT-cBAT',
    subgraphVersion: '3.1.0',
    tokenFaucets: ['0x97b99693613aaa74a3fa0b2f05378b8f6a74a893']
  }, {
    prizePool: '0x95bca36b53ab0c54b162672454fe4be869a6f9ca',
    symbol: 'USDC-0x95bca3',
    subgraphVersion: '3.3.2'
  }, {
    prizePool: '0xc8e1ea1afb7361cd647ad1a54a6c074f1174eb6e',
    symbol: 'BAT-0xc8e1ea',
    subgraphVersion: '3.3.2'
  }, {
    prizePool: '0x84ed0f89c033fe7dadfc4d5f2a516ebd9dc15644',
    symbol: 'DAI-0x84ed0f',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0xe19b8887677432707ae4dd1ce6b50ef9abd44bb6',
    symbol: 'USDC-0xe19b88',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x7355f97fBA5237aEdFE2CdAad50A4eA3cF070A98',
    symbol: 'FAST-DAI-0x7355f9',
    subgraphVersion: '3.3.8'
  }, {
    prizePool: '0x8A358f613ddCca865D005414c1690920E4e9b132',
    symbol: 'LP',
    subgraphVersion: '',
    tokenFaucets: ['0x97B99693613aaA74A3fa0B2f05378b8F6A74a893']
  }], _PRIZE_POOL_ADDRESSES[NETWORK.bsc] = [{
    prizePool: '0x06D75Eb5cA4Da7F7C7A043714172CF109D07a5F8',
    symbol: 'CAKE-0x06D75E',
    subgraphVersion: '3.4.3'
  }, {
    prizePool: '0x2f4Fc07E4Bd097C68774E5bdAbA98d948219F827',
    symbol: 'WBNB-0x2f4Fc0',
    subgraphVersion: '3.4.3'
  }], _PRIZE_POOL_ADDRESSES[NETWORK.polygon] = [{
    prizePool: '0x887e17d791dcb44bfdda3023d26f7a04ca9c7ef4',
    symbol: 'USDT-0x887E17',
    subgraphVersion: '3.3.8',
    tokenFaucets: ['0x90a8d8ee6fdb1875028c6537877e6704b2646c51', '0x951A969324127Fcc19D3498d6954A296E3B9C33c', '0x12533c9fe479ab8c27e55c1b7697e0647fadb153']
  }, {
    prizePool: '0xee06abe9e2af61cabcb13170e01266af2defa946',
    symbol: 'USDC-0xee06ab',
    subgraphVersion: '3.4.3',
    tokenFaucets: ['0x6cbc003fe015d753180f072d904ba841b2415498']
  }, {
    prizePool: '0x2aC049f07d56Ed04F84Ff80022A71a1A2d8cE19b',
    symbol: 'POOL-0x2aC049',
    subgraphVersion: ''
  }], _PRIZE_POOL_ADDRESSES[NETWORK.celo] = [{
    prizePool: '0x6F634F531ED0043B94527F68EC7861B4B1Ab110d',
    symbol: 'CELO-cUSD',
    subgraphVersion: '3.4.5',
    tokenFaucets: ['0xc777e1db58c386b8827bc1321fc2fef03ee5a7b7']
  }, {
    prizePool: '0xbe55435BdA8f0A2A20D2Ce98cC21B0AF5bfB7c83',
    symbol: 'CELO-cEUR',
    subgraphVersion: '3.4.5',
    tokenFaucets: ['0xd7bb81038d60e3530b9d550cd17de605bd27b937']
  }], _PRIZE_POOL_ADDRESSES),
  POD_ADDRESSES: (_POD_ADDRESSES = {}, _POD_ADDRESSES[NETWORK.mainnet] = [{
    // DAI Pod
    pod: '0x2f994e2E4F3395649eeE8A89092e63Ca526dA829',
    prizePool: '0xEBfb47A7ad0FD6e57323C8A42B2E5A6a4F68fc1a'
  }, {
    // USDC Pod
    pod: '0x386EB78f2eE79AddE8Bdb0a0e27292755ebFea58',
    prizePool: '0xde9ec95d7708B8319CCca4b8BC92c0a3B70bf416'
  }], _POD_ADDRESSES[NETWORK.rinkeby] = [{
    // DAI Pod
    pod: '0x4A26b34A902045CFb573aCb681550ba30AA79783',
    prizePool: '0x4706856FA8Bb747D50b4EF8547FE51Ab5Edc4Ac2'
  }], _POD_ADDRESSES),
  LP_PRIZE_POOL_METADATA: (_LP_PRIZE_POOL_METADA = {}, _LP_PRIZE_POOL_METADA[NETWORK.mainnet] = [{
    prizePool: '0x3af7072d29adde20fc7e173a7cb9e45307d2fb0a',
    tokens: {
      ticket: {
        address: '0xeb8928ee92efb06c44d072a24c2bcb993b61e543',
        name: 'PT UNI-V2 LP Ticket',
        symbol: 'PTUNI POOL-ETH'
      },
      underlyingToken: {
        address: '0x85cb0bab616fe88a89a35080516a8928f38b518b',
        dex: DEXES.UniSwap,
        name: 'Uniswap POOL/ETH LP',
        pair: 'POOL/ETH',
        symbol: 'UNI-V2 LP',
        token1: {
          symbol: 'POOL',
          address: '0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e'
        },
        token2: {
          symbol: 'ETH',
          address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2' // WETH

        }
      },
      tokenFaucetDripToken: {
        address: '0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e',
        symbol: 'POOL'
      }
    },
    tokenFaucets: ['0x9a29401ef1856b669f55ae5b24505b3b6faeb370']
  }], _LP_PRIZE_POOL_METADA[NETWORK.rinkeby] = [{
    prizePool: '0x8A358f613ddCca865D005414c1690920E4e9b132',
    tokens: {
      ticket: {
        address: '0x9b8c6fd165e0bffb93e6f2cf564d2cc7271e120f',
        name: 'PT UNI-V2 LP Ticket',
        symbol: 'PTUNI POOL-ETH'
      },
      underlyingToken: {
        address: '0x91A590A2D78c71775318524c198a0f2000112108',
        dex: DEXES.UniSwap,
        name: 'Uniswap POOL/ETH LP Rinkeby',
        pair: 'POOL/ETH',
        symbol: 'UNI-V2 LP',
        token1: {
          symbol: 'POOL',
          address: '0xc4E90a8Dc6CaAb329f08ED3C8abc6b197Cf0F40A'
        },
        token2: {
          symbol: 'ETH',
          address: '0xc778417e063141139fce010982780140aa0cd5ab'
        }
      },
      tokenFaucetDripToken: {
        address: '0xc4E90a8Dc6CaAb329f08ED3C8abc6b197Cf0F40A',
        symbol: 'POOL'
      }
    },
    tokenFaucets: ['0x97B99693613aaA74A3fa0B2f05378b8F6A74a893']
  }], _LP_PRIZE_POOL_METADA),
  POOL_PRIZE_POOL_ADDRESSES: (_POOL_PRIZE_POOL_ADDR = {}, _POOL_PRIZE_POOL_ADDR[NETWORK.mainnet] = ['0x396b4489da692788e327e2e4b2b0459a5ef26791'], _POOL_PRIZE_POOL_ADDR[NETWORK.polygon] = ['0x2aC049f07d56Ed04F84Ff80022A71a1A2d8cE19b'], _POOL_PRIZE_POOL_ADDR[NETWORK.rinkeby] = ['0x4706856fa8bb747d50b4ef8547fe51ab5edc4ac2'], _POOL_PRIZE_POOL_ADDR)
});

export { ARBITRUM_NETWORKS, AVALANCHE_NETWORKS, CELO_NETWORKS, CURRENCIES, DEXES, ETHEREUM_NETWORKS, GOVERNANCE_CONTRACT_ADDRESSES, MINUTES_PER_DAY, MINUTES_PER_HOUR, NETWORK, OPTIMISM_NETWORKS, POLYGON_NETWORKS, POOL_ADDRESSES, SECONDS_PER_DAY, SECONDS_PER_HOUR, SECONDS_PER_MINUTE, SECONDS_PER_YEAR, V3, addBigNumbers, addPoolTokenToMetaMask, addTokenToMetaMask, addTokenTotalUsdValue, addUsdcTicketTokenToMetaMask, amountMultByUsd, calculateApr, calculateCreamBorrowApy, calculateCreamSupplyApy, calculateEstimatedCompoundPrizeWithYieldUnformatted, calculateLPTokenPrice, calculateOdds, calculatePercentageOfBigNumber, calculateUsersOdds, calculatedEstimatedAccruedCompTotalValueUsdScaled, chainIdToNetworkName, dToM, dToMs, dToS, dedupeArray, deleteQueryParam, deserializeBigNumbers, displayPercentage, divideBigNumbers, formatCurrencyNumberForDisplay, formatNumberForDisplay, formatUnformattedBigNumberForDisplay, getAmount, getAmountFromUnformatted, getChainIdByAlias, getGovernanceSubgraphUrl, getLootBoxKey, getMaxPrecision, getMinPrecision, getNetworkNameAliasByChainId, getNetworkNiceNameByChainId, getPrecision, getPrizePoolSymbol, getSecondsRemainingInPrizePeriod, getSecondsSinceEpoch, getTimeBreakdown, getTokenColour, msToD, msToS, msToSeconds, numberWithCommas, prettyNumber, pushQueryParam, replaceQueryParam, sToD, sToM, sToMs, safeParseUnits, sharesAmountToUnderlyingAmount, shorten, stringWithPrecision, subtractDates, toNonScaledUsdString, toScaledUsdBigNumber, underlyingAmountToSharesAmount, unionProbabilities };
//# sourceMappingURL=utilities.esm.js.map
